/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import HouseManual from './HouseManual'

/**
 * The InlineResponse20032 model module.
 * @module model/InlineResponse20032
 * @version 1.0.0
 */
export default class InlineResponse20032 {
  /**
   * Constructs a new <code>InlineResponse20032</code>.
   * @alias module:model/InlineResponse20032
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20032</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20032} obj Optional instance to populate.
   * @return {module:model/InlineResponse20032} The populated <code>InlineResponse20032</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20032()

      if (data.hasOwnProperty('house_manuals')) {
        obj['house_manuals'] = ApiClient.convertToType(data['house_manuals'], [HouseManual])
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
    }
    return obj
  }

  /**
   * @member {Array.<module:model/HouseManual>} house_manuals
   */
  house_manuals = undefined
  /**
   * @member {Number} id
   */
  id = undefined
}
